<template>
	<TemplateBase
		:is-sales="isSales"
		class="bg-gray-50"
	>
		<div
			class="bg-gradient-to-r from-purple-700 to-purple-900 w-full flex flex-col justify-end items-center pt-24 mb-32"
		>
			<div
				class="container flex flex-col items-center gap-16 max-w-screen-md -mb-16"
			>
				<div class="w-full">
					<LazyAtomBreadcrumbs
						v-if="breadcrumbs"
						:breadcrumbs="breadcrumbs"
						class="text-title-size-xs"
					/>
				</div>
				<div class="flex items-center gap-12 w-full">
					<LazyAtomImage
						v-if="featuredImage"
						:src="featuredImage.src"
						:alt="featuredImage.alt"
						:width="150"
						:height="150"
						fit="cover"
						class="shrink-0"
						img-class="rounded ring-purple-800 shrink-0 mt-3"
					/>
					<div class="flex flex-col gap-7">
						<div
							class="flex flex-col gap-3"
						>
							<h2 class="text-functional-size-2xs uppercase tracking-wider text-white/50">
								Categorie
							</h2>
							<div class="flex flex-wrap gap-4">
								<AtomLink
									size="sm"
									variant="white"
									:url="`/blog/${category.slug}`"
									:title="category.name"
									class="text-functional-size-sm underline text-white hover:text-purple-200"
								>
									{{ category.name }}
								</AtomLink>
							</div>
						</div>
						<div
							v-if="tags && tags.length > 0"
							class="flex flex-col gap-3"
						>
							<h2 class="text-functional-size-2xs uppercase tracking-wider text-white/50">
								<span v-if="tags.length === 1">Label</span>
								<span v-else>Labels</span>
							</h2>
							<div class="flex flex-wrap gap-4">
								<AtomLabel
									v-for="tag in tags"
									:key="tag.id"
									size="sm"
									variant="white"
								>
									{{ tag.tag }}
								</AtomLabel>
							</div>
						</div>
						<div
							class="flex flex-col gap-3"
						>
							<h2 class="text-functional-size-2xs uppercase tracking-wider text-white/50">
								Geschreven door
							</h2>
							<div class="flex flex-wrap gap-4 text-white text-functional-size-sm">
								{{ writer.firstname }} {{ writer.lastname }}
							</div>
						</div>
					</div>
				</div>
				<AtomCard
					class="flex flex-col gap-8 py-16 px-8 md:px-16 w-full"
				>
					<AtomTitle
						tag="h1"
						size="3xl"
						class="uppercase text-purple-900"
					>
						{{ title }}
					</AtomTitle>
					<p class="text-purple-800">
						<AtomTitle
							tag="span"
							size="lg"
						>
							{{ subtitle }}
						</AtomTitle>
					</p>
					<slot name="intro" />
				</AtomCard>
			</div>
		</div>
		<div>
			<slot />
		</div>
	</TemplateBase>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { StrapiBlogCategoryType } from '#base/core/types/cms/StrapiBlogCategoryType';
import type { StrapiBlogTagType } from '#base/core/types/cms/StrapiBlogTagType';
import type { StrapiWriterType } from '#base/core/types/cms/StrapiWriterType';

defineProps<{
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
	title: string;
	subtitle: string;
	featuredImage?: {
		alt: string;
		src: string;
		placeholderSrc?: string;
	};
	tags?: StrapiBlogTagType[];
	category: StrapiBlogCategoryType;
	writer: StrapiWriterType;
}>();
</script>
